import {memo} from 'react';
import {Box, Typography, Paper, Divider} from '@mui/material';
import Button from '@jobseeker/lotus/elements/Button';
import {FaBookmark, FaInfo, FaStar, FaBriefcase} from 'react-icons/fa';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';

import type {JobListProps} from './type';
import {jobListPropsAreEqual} from './areEqual';
import {Dot} from '@jobseeker/lotus/icons';
import {Image} from '@jobseeker/lotus/components/Image';

const ModernJobList = (props: JobListProps) => {
  const IsLarge = useIsLargeDevice('sm');
  return (
    <Paper
      elevation={3}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        borderRadius: 2,
        py: 1.5,
        // pl: 5.5,
        ml: 2,
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
      }}
    >
      <Box sx={{position: 'relative'}}>
        <Box
          component={'img'}
          sx={{
            width: '50px',
            height: '50px',
            backgroundColor: '#ededed',
            position: 'absolute',
            left: '-20px',
            top: '-3px',
            borderRadius: 3,
          }}
          src={props.companyImgUrl}
        ></Box>
        <Box
          sx={{
            position: 'relative',
            ml: 5.5,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {!IsLarge && (
            <Typography
              component={'p'}
              variant="body2"
              color={'secondary.light'}
            >
              <FaBriefcase />
              &nbsp; {props.companyName}
            </Typography>
          )}
          <Typography component={'p'} variant="body1" sx={{fontWeight: '500'}}>
            {props.title}
          </Typography>

          <Typography
            component={'div'}
            variant="body2"
            color={'secondary.light'}
            sx={{
              display: 'flex',
              gap: '7px',
              flexWrap: 'wrap',
              alignItems: 'center',
            }}
          >
            {IsLarge && (
              <>
                <Typography component={'span'} variant="body2">
                  <FaBriefcase />
                  &nbsp; {props.companyName}
                </Typography>
                <Image
                  src={Dot}
                  width={4}
                  height={4}
                  alt="."
                  style={{margin: '0 8px'}}
                />
              </>
            )}
            <Typography component={'span'} variant="body2">
              {props.experiance}
            </Typography>
            <Image
              src={Dot}
              width={4}
              height={4}
              alt="."
              style={{margin: '0 8px'}}
            />
            <Typography component={'span'} variant="body2">
              {props.location}
            </Typography>
            {IsLarge && (
              <>
                <Image
                  src={Dot}
                  width={4}
                  height={4}
                  alt="."
                  style={{margin: '0 8px'}}
                />
                <Typography component={'span'} variant="body2">
                  {/* {props.date} */}
                </Typography>
              </>
            )}
          </Typography>
        </Box>
      </Box>
      {IsLarge && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'end',
            gap: '10px',
            padding: '0 10px',
          }}
        >
          <Button
            shape={'circular'}
            icon={<FaBookmark />}
            size="small"
            color="secondary"
            variant={'outlined'}
            onClick={() => props.onPremiumClick && props.onPremiumClick(props)}
          >
            Premium
          </Button>

          <Button
            shape={'circular'}
            icon={<FaInfo />}
            size="small"
            color="secondary"
            variant={'outlined'}
            onClick={() => props.onInfoClick && props.onInfoClick(props)}
          >
            Info
          </Button>
          <Divider orientation="vertical" flexItem />
          <Button
            shape={'circular'}
            icon={<FaStar />}
            size="small"
            variant={'contained'}
            onClick={() => props.onSaveClick && props.onSaveClick(props, false)}
          >
            Save
          </Button>
        </Box>
      )}
    </Paper>
  );
};

export default memo(ModernJobList, jobListPropsAreEqual);
